
import { defineComponent, PropType, ref } from 'vue'
export default defineComponent({
  props: {
    imgArr: {
      type: Array as PropType<string[]>
    }
  },
  setup (props) {
    const picIndex = ref(0)
    const swipe = (move: number) => {
      if (!props.imgArr) return
      picIndex.value = (picIndex.value + props.imgArr.length + move) % props.imgArr.length
    }
    return {
      picIndex,
      swipe
    }
  }
})
